<template>
    <div v-show="visible">
        <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="340px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item prop="name" label="名称" >
                    <el-input v-model="form.name" maxlength="200"  placeholder="第几节课"></el-input>
                </el-form-item>

                <el-form-item   prop="startTime" label="开始时间">
                    <el-time-select
                        placeholder="上课开始时间"
                        v-model="form.startTime"
                        :picker-options="{
                        start: '07:00',
                        step: '00:05',
                        end: '21:30'
                        }">
                    </el-time-select>
                </el-form-item>

                <el-form-item   prop="endTime" label="结束时间">
                    <el-time-select
                        placeholder="上课结束时间"
                        v-model="form.endTime"
                        :picker-options="{
                        start: '07:30',
                        step: '00:05',
                        end: '21:30'
                        }">
                    </el-time-select>
                </el-form-item>
                <el-form-item   prop="orderNum" label="排序号">
                    <el-input v-model="form.orderNum" maxlength="2" type="number" style="width:80px;"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取消</el-button>
                <el-button type="primary" @click="save()">确定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    
    export default {
        data(){
            return{
                visible: false,
                form:{
                    deptId:"",
                    name:"",
                    startTime:"",
                    endTime:""
                },
                rules: {
                    name: [
                        { required: true, message: '请输入名称', trigger: 'blur' }
                    ],
                    startTime: [
                        { required: true, message: '请选择开始时间', trigger: 'blur' }
                    ],
                    endTime: [
                        { required: true, message: '请选择结束时间', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        mounted:function () {
        },
        methods:{
            init(deptId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.deptId=deptId;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.classHoursAddUrl;
                        let data = {
                            name: this.form.name,
                            startTime: this.form.startTime,
                            endTime: this.form.endTime,
                            deptId: this.form.deptId,
                            orderNum: this.form.orderNum 
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/base/classHours/Add.vue